<!-- travel/index travel-index -->

<template>
  <div>
    <div class="page">
      <div class="content-box">
        <city-select :cate-id="cateId" :search-stop="true" @searchKey="search($event)"></city-select>

        <div class="body-box">
          <ads-images :ad-id="cateInfo.adsId" />

          <div class="mt10 content-box">
            <van-dropdown-menu>
              <van-dropdown-item v-model="levelFilterValue" :options="levelOption" @change="filter" />
              <van-dropdown-item v-model="priceFilterValue" :options="priceOption" title="价格"
                @change="filter('price', $event)" />
              <van-dropdown-item v-model="distanceFilterValue" :options="distanceOption" title="距离"
                @change="filter('distance', $event)" />
              <van-dropdown-item v-model="gradeFilterValue" :options="gradeOption" title="评分"
                @change="filter('grade', $event)" />
            </van-dropdown-menu>

            <div class="body-box">
              <van-list v-model="loading" :error.sync="error" :finished="finished" :finished-text="finishedText"
                :immediate-check="false" :offset="100" error-text="请求失败，点击重新加载 G" @load="getScenicSpotsList">
                <div v-for="item in scenicSpotList" :key="item.brandShopId"
                  style="margin: 8px;background-color: #FFFFFF;border-radius: 8px;">
                  <van-row>
                    <van-col span="10">
                      <van-image :src="item.logo" radius="4" style="width: 120px;margin-left: 16px;margin-top: 20px;"
                        @click="$router.push({ path: 'travel-detail', query: { id: item.brandShopId } })"></van-image>
                    </van-col>
                    <van-col span="14" style="padding: 16px 0;"
                      @click="$router.push({ path: 'travel-detail', query: { id: item.brandShopId } })">
                      <van-row>
                        <van-col span="24" style="font-size: 18px;font-weight: 600;color: #4a4a4a"> {{ item.name }}
                        </van-col>
                      </van-row>
                      <van-row class="van-hairline--bottom">
                        <van-col span="24" style="color: #999999;font-size:12px;">
                          <van-row>
                            <van-col class="left-content" span="24">
                              <p>
                                <span style="font-weight: bold;color: #ECA805;font-size: 21px;">
                                  {{ getExtInfo(item.extInfo).commentGrade }}
                                </span> / 5分
                                <span style="float: right;margin-right: 8px;"> {{ item.distance }} KM </span>
                              </p>
                              <p class="van-ellipsis">{{ item.address }}</p>
                              <p class="van-ellipsis">开放时间：{{ item.openTime }}</p>

                              <p v-if="item.goodsCount > 0">
                                <img alt=""
                                  src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/t81502o1cbv1u2pptwopkson.png"
                                  style="  width: 24px;  height: 24px;display: block;margin-top: 4px;float: left" />
                                <span
                                  style="color: #f84f43;font-size: 21px;line-height: 24px;display: block;margin-top: 4px;float: left">
                                  {{ ((item.goodsMinPrice || item.price) / 100).toFixed(2) }}
                                  <span style="font-size: 12px;">起</span></span>
                              </p>
                              <p v-else-if="getExtInfo(item.extInfo).BusinessStatus === 6"> 暂停营业 </p>
                              <p v-else-if="getExtInfo(item.extInfo).BusinessStatus === 5"> 尚未营业 </p>
                              <p v-else> 免费开放 </p>
                            </van-col>
                          </van-row>
                        </van-col>
                      </van-row>
                    </van-col>
                  </van-row>
                </div>
              </van-list>
            </div>
          </div>
        </div>
      </div>
    </div>

    <PageFooter :active="0"></PageFooter>
  </div>
</template>

<script>
import { Dialog } from "vant";
import GoodsListBlock from "@/components/common/GoodsListBlock";
import AdsImages from "@/components/common/ads-images";
import CitySelect from "@/components/common/city-select";
import MallSortTable from "@/components/common/MallSortTable";
import { GOODS_CATE_INFO, MallModules } from "@/api/constant";
import { api_get_hospital_top_list, api_get_scenic_spot_list } from "@/api/goods-api";
import TabBarBook from "@/components/common/tabbar-books";
import PageFooter from "@/components/common/page-footer";
import { wx_get_jsapi_ticket, toChannelIndex } from "@/api/user";
import { get_user_poi_location } from "@/util/wxSdk";

export default {
  name: "travel-index",

  components: { PageFooter, TabBarBook, GoodsListBlock, AdsImages, CitySelect, MallSortTable },

  data() {
    return {
      tabActive: 0,
      cateList: [],
      goodsList: [],
      cateInfo: GOODS_CATE_INFO.travel,
      cateId: GOODS_CATE_INFO.travel.id,
      error: false,
      loading: false,
      finished: false,
      finishedText: "没有更多了 S",
      scenicSpotList: [],
      pi: 0,
      searchKey: '',
      notice: '',
      localResult: false,
      pageCount: 0,
      levelFilterValue: 0,
      distanceFilterValue: 1,
      priceFilterValue: 0,
      gradeFilterValue: 0,
      levelOption: [
        { text: '等级', value: 0 },
        { text: '5A', value: 5 },
        { text: '4A', value: 4 },
        { text: '3A', value: 3 },
        { text: '2A', value: 2 },
        { text: 'A', value: 1 },
      ],
      priceOption: [
        { text: '清除排序', value: 0 },
        { text: '价格从低到高', value: 1 },
        { text: '价格从高到低', value: 2 },
      ],
      distanceOption: [
        { text: '清除排序', value: 0 },
        { text: '距离由近到远', value: 1 },
        { text: '距离由远到近', value: 2 },
      ],
      gradeOption: [
        { text: '清除排序', value: 0 },
        { text: '评分从低到高', value: 1 },
        { text: '评分从高到低', value: 2 },
      ],
    }
  },

  computed: {
    poi: function () {
      return sessionStorage.getItem("USER_CURRENT_POI_LAT");
    }
  },

  mounted() {
    budo_log.info("#160 created", this)

    this.load_data()

    window.onscroll = this.doScroll;
  },

  methods: {
    load_data() {
      toChannelIndex(this.cateId).then(res => {
        if (res.code != 0) {

          budo_log.info("#201 go bind card")

          Dialog.confirm({ message: res.msg + ", 跳转到绑卡页?" }).then(() => {
            this.$router.push({ path: '/bind-card' });
          })
          return
        }

        this.$store.dispatch('store_get_user_info')

        const module = MallModules.find((mall) => mall.topCateId === 7);
        this.$store.commit("SET_MALL_MODULE", module);
        this.searchKey = this.$route.query.searchKey;

        // 非微信 直接拿数据
        if (navigator.userAgent.indexOf("micromessenger") < 0) {
          this.getScenicSpotsList(0, 10, this.searchKey);
          return
        }

        // 微信 获取到定位后 再拿数据
        wx_get_jsapi_ticket(encodeURIComponent(window.location.href)).then(res => {
          if (res.code === 0) {
            get_user_poi_location(res, (result) => {
              this.localResult = result;
              this.scenicSpotList = [];
              this.pi = 0;
              this.getScenicSpotsList(0, 10, this.searchKey);
            })
          }
        });
      })
    },

    filter(type, value) {
      if (type === 'price') {
        this.distanceFilterValue = 0;
        this.gradeFilterValue = 0;
      } else if (type === 'grade') {
        this.distanceFilterValue = 0;
        this.priceFilterValue = 0;
      } else if (type === 'distance') {
        this.gradeFilterValue = 0;
        this.priceFilterValue = 0;
      }

      this.pi = 0;
      this.scenicSpotList = [];
      this.getScenicSpotsList();
    },

    getExtInfo(str) {
      const extInfo = JSON.parse(str);
      return extInfo || {};
    },

    search(keyVal) {
      this.$router.push({ path: 'travel-index', query: { 'searchKey': keyVal } });
    },

    getScenicSpotsList() {
      this.finishedText = "加载中 G ...";
      this.pi++;

      api_get_scenic_spot_list(this.pi,
        10,
        this.searchKey,
        this.levelFilterValue,
        this.distanceFilterValue,
        this.priceFilterValue,
        this.gradeFilterValue,
        this.$route.query.brand_id,
        this.$route.query.city_code).then(res => {
          this.scenicSpotList = this.scenicSpotList.concat(
            res.data.records
          );

          budo_log.info('#229 api_get_scenic_spot_list', res.data)
          if (this.scenicSpotList.length >= res.data.total) {
            this.finishedText = "没有更多了 T";
            this.finished = true;
          }

          if (res.data.total === 0) {
            this.finishedText = "看看其它的吧 H";
            this.finished = true;
          }

          this.loading = false;
        }).catch((error) => {
          budo_log.info('#260 api_get_scenic_spot_list err', error)
          this.loading = false;
          this.error = true;
        });
    },

    onChange(index) {
      budo_log.info('#266 onChange', index)

      api_get_hospital_top_list(index + 1, 8, true).then(res => {
        this.topList = res.data;
      })
    },

    doScroll() {
      if (this.timerId) clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        // 获取页面滚动距离之后设置给当前路由的元信息
        this.$route.meta.y = window.pageYOffset;
        budo_log.debug('#273 doScroll pageYOffset', window.pageYOffset)
      }, 300);
    },

    toDetail(cateId, topicId) {
      if (topicId > 0) {
        this.$router.replace({ path: 'topic-detail', query: { topicId: topicId, buyFlag: '1' } })
        return
      }

      this.$router.replace({ path: 'cate-index', query: { cateId: cateId } })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .van-grid-item__content {
    padding: 4px;
  }
}

.left-content {
  p {
    line-height: 22px;
    height: 22px;
    padding: 0;
    margin: 0;
  }
}

.page {
  background-color: #EDF0F5;
  padding-bottom: 120px;
  min-height: 100vh;

  .content-box {
    .box1 {
      padding: 0 11px;
      background-color: white;

      ::v-deep {
        .van-dropdown-menu__bar {
          box-shadow: unset;
        }
      }
    }

    .body-box {
      padding: 10px 0;

      .box2 {
        padding: 0 15px;

        .my-swipe {
          border-radius: 5px;

          .van-swipe-item {
            color: #fff;
            font-size: 20px;
            line-height: 150px;
            text-align: center;
            background-color: #39a9ed;
          }
        }
      }

      .box3 {
        padding: 0 15px;
        color: #9A9A9A;
        font-size: 12px;
        margin: 14px 0;
      }

      .box4 {
        // height: 100px;
        background: #FFFFFF;
        border-radius: 5px;
        padding: 10px;
        font-size: 12px;
        color: #333333;
      }

      .box5 {


        //  background: #FFFFFF;
        border-radius: 8px;
        margin: 10px 15px;
      }

      .box7 {
        background: #FFFFFF;
        border-radius: 8px;
        margin: 10px 15px;
      }

      .box6 {
        padding: 0;

        .goods-box {
          margin-top: 10px;

          .goods-item {
            width: 133px;
            height: 261px;
            background: #FFFFFF;
            border-radius: 4px;
            padding: 20px;
          }
        }
      }
    }
  }
}
</style>
